import {
  AfterContentChecked,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { CustomEventIglu } from '@planone/bau365/feature-tracking';

import { Download } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-download-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.scss'],
})
export class DownloadListComponent implements OnChanges, AfterContentChecked {
  @Input() fairId: string | undefined = undefined;
  @Input() exhibitorId: string | undefined = undefined;
  @Input() exhibitorName: string | undefined = undefined;
  @Input() downloads?: Download[] = [];
  @Input() limit = 3;
  @Input() flowsContent = false;
  @Output() downloadClick = new EventEmitter<{ download: Download; element: EventTarget | null }>();

  @ViewChild('downloadElement') downloadElement?: ElementRef;
  @ViewChild('referenceElement') referenceElement?: ElementRef;

  maxHeight = 0;
  downloadsOverflowing = false;
  downloadsExpanded = false;

  snowplowIglu = CustomEventIglu;

  private identifyDownloadOverflow() {
    if (this.downloadElement && this.referenceElement) {
      this.downloadsOverflowing =
        this.referenceElement.nativeElement.offsetHeight > this.downloadElement.nativeElement.offsetHeight;
      this.maxHeight = this.downloadsExpanded
        ? this.referenceElement.nativeElement.offsetHeight
        : this.downloadElement.nativeElement.offsetHeight;
    }
  }

  ngAfterContentChecked() {
    this.identifyDownloadOverflow();
  }

  ngOnChanges() {
    this.identifyDownloadOverflow();
  }

  @HostListener('window:resize')
  onResize() {
    this.identifyDownloadOverflow();
  }

  toggle() {
    this.downloadsExpanded = !this.downloadsExpanded;
  }

  identifyDownload(_index: number, download: Download): string {
    return download.path;
  }
}
